import { formatMoney } from "@justhome/common";
import useLocale from "@lib/hooks/useLocale";
import { FC } from "react";

interface MoneyProps {
  value: string | number | undefined;
  fractionDigits?: boolean;
}

const Money: FC<MoneyProps> = ({ value, fractionDigits }) => {
  const locale = useLocale();
  return formatMoney(value, fractionDigits, locale === "immo" ? "de" : locale);
};

export default Money;
